// Vuex 때 처럼 create* 함수를 제공한다.
import { createWebHistory, createRouter } from "vue-router";
import { useAuthStore } from '@/store';

const routes = [
  {
    path: "/",
    name: "defaultLayout",
    component: () => import("@/layouts/DefaultLayout.vue"),
    children: [
      {
        path: "/",
        name: "Home",
        component: () => import("@/views/HomeView"), // 동적 import
      },
      {
        path: "/login",
        name: "Login",
        component: () => import("@/views/admin/AdminLogin"),
      },
      {
        path: "/payment/complete",
        name: "PaymentComplete",
        component: () => import("@/views/payment/PaymentComplete"),
        meta: { title: '결제 완료' }
      },
      {
        // 어떤 라우트에도 맞지 않는 주소 (라우트 목록 순서와 무관하게 마지막에 매칭됨)
        path: "/:pathMatch(.*)*",
        name: "NotFound",
        component: () => import("@/views/NotFoundView"),
        meta: { title: '페이지를 찾을 수 없습니다' }
      },
    ],
  },
  {
    path: "/",
    name: "adminLayout",
    component: () => import("@/layouts/AdminLayout.vue"),
    meta: { requiresAuth: true }, // 이 아래 자식 라우트는 전부 로그인 필요
    children: [
      {
        path: "/admin",
        name: "Admin",
        component: () => import("@/views/admin/AdminHome"),
      },
      {
        path: "/admin/schedule",
        name: "AdminSchedule",
        component: () => import("@/views/admin/AdminSchedule"),
        meta: {
          title : '시간표'
        },
        
      },
      {
        path: "/admin/schedule/detail",
        name: "AdminScheduleDetail",
        component: () => import("@/views/admin/AdminScheduleDetail"),
        meta: {
          title : '시간표'
        },
      },
      {
        path: "/admin/student",
        name: "AdminStudent",
        component: () => import("@/views/admin/AdminStudent"),
        meta: {
          title : '학생관리'
        },
      },
      {
        path: "/admin/student/detail",
        name: "AdminStudentDetail",
        component: () => import("@/views/admin/AdminStudentDetail"),
        meta: {
          title : '학생관리'
        },
      },
      {
        path: "/admin/class",
        name: "AdminClass",
        component: () => import("@/views/admin/AdminClass"),
        meta: {
          title : '수업관리'
        },
      },
      {
        path: "/admin/class/edit",
        name: "AdminClassEdit",
        component: () => import("@/views/admin/AdminClassEdit"),
        meta: {
          title : '수업관리'
        },
      },
      {
        path: "/admin/teacher",
        name: "AdminTeacher",
        component: () => import("@/views/admin/AdminTeacher"),
        meta: {
          title : '강사관리'
        },
      },
      {
        path: "/admin/teacher/edit",
        name: "AdminTeacherEdit",
        component: () => import("@/views/admin/AdminTeacherEdit"),
        meta: {
          title : '강사관리'
        },
      },
      {
        path: "/admin/setting",
        name: "AdminSetting",
        component: () => import("@/views/admin/AdminSetting"),
        meta: {
          title : '문자발송'
        },
      },
      {
        path: "/admin/invoice",
        name: "AdminInvoice",
        component: () => import("@/views/admin/AdminInvoice"),
        meta: {
          title : '결제관리'
        },
      },
    ],
  },
];

export const router = createRouter({
  history: createWebHistory(),
  scrollBehavior(to, from, savedPosition) {
    console.log('savedPosition : ', savedPosition)
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  },
  routes,
}
 
);

router.afterEach((to) => {
  document.title  = to.meta.title === undefined ? '학원관리' : to.meta.title;
});

router.beforeEach((to) => {
  // 부모(adminLayout)에 requiresAuth가 있으면 자식 라우트 전부 해당됨
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  if (!requiresAuth) return true;

  const authStore = useAuthStore();
  if (authStore.user) return true;

  return { path: "/login" };
});